/**
 * useExpedientesSearch
 * Busca expedientes por q (telefono, directoryId o peopleId).
 */
import { useQuery } from '@tanstack/react-query';
import { searchExpedientes } from '@/services/expedientes.service';
import { PARTNER_ID } from '@/constants';

export function useExpedientesSearch(q: string, enabled: boolean) {
  const query = useQuery({
    queryKey: ['expedientes', 'search', q, PARTNER_ID],
    queryFn: () => searchExpedientes(q, PARTNER_ID),
    enabled: enabled && q.trim().length >= 2,
  });

  return {
    results: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
